import { create } from 'zustand';

import { Fact } from '@/types';

interface Store {
  popupFact: Fact | null;
  setPopupFact: (fact: Fact | null) => void;

  popupFactFromTranscription: { factId: string; caseId: string } | null;
  setPopupFactFromTranscription: (popup: { factId: string; caseId: string } | null) => void;

  // Reference drawer state
  referenceDrawer: {
    isOpen: boolean;
    factId: string | null;
    chunkId: string | null;
    caseId: string | null;
  };
  openReferenceDrawer: (params: { factId?: string; chunkId?: string; caseId?: string }) => void;
  closeReferenceDrawer: () => void;
}

export const useStore = create<Store>((set) => ({
  popupFact: null,
  setPopupFact: (fact: Fact | null) => set({ popupFact: fact }),

  popupFactFromTranscription: null,
  setPopupFactFromTranscription: (popup: { factId: string; caseId: string } | null) =>
    set({ popupFactFromTranscription: popup }),

  // Reference drawer state
  referenceDrawer: {
    isOpen: false,
    factId: null,
    chunkId: null,
    caseId: null,
  },
  openReferenceDrawer: ({ factId, chunkId, caseId }) =>
    set({
      referenceDrawer: {
        isOpen: true,
        factId: factId || null,
        chunkId: chunkId || null,
        caseId: caseId || null,
      },
    }),
  closeReferenceDrawer: () =>
    set({
      referenceDrawer: {
        isOpen: false,
        factId: null,
        chunkId: null,
        caseId: null,
      },
    }),
}));
